import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — S.Kumars</title>
      </Helmet>

      <iframe
        src="/pages/privacy-policy.html"
        title="Privacy Policy"
        style={{ width: "100%", minHeight: "100vh", border: "none" }}
      />
    </>
  );
}
